import { render, staticRenderFns } from "./threeBody.vue?vue&type=template&id=73c1ffad&scoped=true&"
import script from "./threeBody.vue?vue&type=script&lang=js&"
export * from "./threeBody.vue?vue&type=script&lang=js&"
import style0 from "./threeBody.vue?vue&type=style&index=0&id=73c1ffad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c1ffad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73c1ffad')) {
      api.createRecord('73c1ffad', component.options)
    } else {
      api.reload('73c1ffad', component.options)
    }
    module.hot.accept("./threeBody.vue?vue&type=template&id=73c1ffad&scoped=true&", function () {
      api.rerender('73c1ffad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/components/threeBody.vue"
export default component.exports